import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { useKeepSiteMark } from "@/lib/site-mark";

/**
 * "Keep the FaceShot ChopShop mark on it": on every studio's pay step
 * (lib/site-mark.ts). Colours come from the surrounding card.
 */
export default function SiteMarkSwitch({ testId = "site-mark", style, disabled = false }: { testId?: string; style?: CSSProperties; disabled?: boolean }) {
  const { t } = useTranslation();
  const [keep, setKeep] = useKeepSiteMark();
  return (
    <label data-testid={testId} style={{ display: "flex", gap: 8, alignItems: "flex-start", fontSize: 13, lineHeight: 1.5, cursor: disabled ? "default" : "pointer", ...style }}>
      <input type="checkbox" data-testid={`${testId}-box`} checked={keep} disabled={disabled}
        onChange={(e) => setKeep(e.target.checked)} style={{ marginTop: 3 }} />
      <span>
        <span style={{ fontWeight: 600 }}>{t("siteMark.keep")}</span>
        <span style={{ display: "block", fontSize: 12, opacity: 0.75 }}>{t("siteMark.hint")}</span>
      </span>
    </label>
  );
}
